<div class="content-container">
  <img src="/assets/img/icons/svgs/briefcase.svg" height="60px" width="60px" alt="briefcase" />
  <h5 class="content-title">Register as an Issuer to Raise Funds</h5>
  <p class="content-subtitle">
    To raise funds on pitchIN, you must register as an issuer. Would you like to proceed?
  </p>
  <div class="button-group">
    <button class="btn btn-primary" (click)="proceed()">Proceed</button>
    <button class="btn" (click)="stay()">Cancel</button>
  </div>
</div>
